import { SvgIcon, SvgIconProps } from '@mui/material'

const StationErrorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 20 20" {...props}>
      <g filter="url(#a)">
        <rect
          x="3"
          y=".727"
          width="14.546"
          height="14.546"
          rx="2.597"
          fill="#ED2121"
        />
        <path
          d="M12.87 3.844h.52a1.039 1.039 0 0 1 1.039 1.039v.52m0 5.194v.52a1.039 1.039 0 0 1-1.04 1.038h-.519m-5.195 0h-.52a1.039 1.039 0 0 1-1.038-1.038v-.52m0-5.195v-.52a1.039 1.039 0 0 1 1.039-1.038h.52m2.597 7.273v1.038M6.117 8h1.039m3.117-4.156v1.039M14.429 8h-1.04M8.715 8a1.558 1.558 0 1 0 3.117 0 1.558 1.558 0 0 0-3.117 0Z"
          stroke="#fff"
          strokeWidth="1.039"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="a"
          x=".922"
          y=".727"
          width="18.701"
          height="18.701"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.078" />
          <feGaussianBlur stdDeviation="1.039" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_25235_40753"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_25235_40753"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  )
}

export default StationErrorIcon
